<template>
    <div>
        <base-header-img img="Page02_02">
            中国领先的<br />
            以心脑专病数字医疗服务为核心的创新公司
        </base-header-img>
        <div class="home_content">
            <img class="icon_home" src="../assets/home-icon_3.png" />
            <div class="home_introduce">
                <div class="home_title">
                    <base-title title="智煜简介" center></base-title>
                    <div class="home_text">
                        北京智煜健康科技有限公司，致力于成为中国领先的专病数字医疗服务为核心的创新公司，专注于心脑血管疾病垂直领域的数字化医疗服务体系，为专病患者提供院外数字化专病诊疗与管理服务，为临床医生专业能力提升与学术交流提供智慧医学引擎及创新工具，为行业机构提供数字化解决方案。
                        <div class="more" @click="$router.push('/about')"></div>
                    </div>
                </div>
            </div>
            <div class="home_dongtai">
                <base-title
                    title="智煜动态"
                    color="#ffffff"
                    center
                    icon="white"
                ></base-title>
                <div class="home_dongtai_content">
                    <div class="dongtai_item" @click="goDetail(4)">
                        <img src="../assets/home-img-4.jpg" />
                        <div class="line"></div>
                        <div class="home_dongtai_text">
                            智煜健康闪耀世界数字疗法大会，引领心脑专病数字医疗未来
                        </div>
                        <div class="dongtai_item_header"></div>
                        <div class="more"></div>
                    </div>
                    <div class="dongtai_item" @click="goDetail(3)">
                        <img src="../assets/home-img-3.jpg" />
                        <div class="line"></div>
                        <div class="home_dongtai_text">
                            智煜健康科技携旗下三款创新医疗产品，亮相第九届天坛会
                        </div>
                        <div class="dongtai_item_header"></div>
                        <div class="more"></div>
                    </div>
                    <div class="dongtai_item" @click="goDetail()">
                        <img src="../assets/home-img-1.png" />
                        <div class="line"></div>
                        <div class="home_dongtai_text">
                            重磅新品即将上市！辈宁智能手表血压仪，提供动态血压监测新方案
                        </div>
                        <div class="dongtai_item_header"></div>
                        <div class="more"></div>
                    </div>
                    <!-- <div class="dongtai_item" @click="goDetail(2)">
                        <img src="../assets/home-img-2.png" />
                        <div class="line"></div>
                        <div class="home_dongtai_text">
                            医阵营全平台上线！为医生提供一站式解决方案
                        </div>
                        <div class="dongtai_item_header"></div>
                        <div class="more"></div>
                    </div> -->
                </div>
            </div>
            <div class="home_jigou">
                <div class="home_jigou_header">
                    <base-title
                        title="合作机构"
                        color="#ffffff"
                        center
                        icon="white"
                    ></base-title>
                </div>
                <img src="../assets/home-img-4.png" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'home',
    methods: {
        goDetail (id) {
            if (!id) {
                return
            }
            this.$router.push({
                path: '/message',
                query: {
                    id: id
                }
            })
        }
    }
}
</script>
<style  scoped>
.home_content {
    background-image: url("../assets/home_bg_01.png");
    background-color: #ffffff;
    background-repeat: no-repeat;
    position: relative;
}
.home_introduce {
    width: 1100px;
    margin: 0 auto;
}
.home_title {
    padding-top: 66px;
    text-align: center;
    position: relative;
}
.home_text {
    font-size: 20px;
    text-align: left;
    font-weight: 300;
    color: rgb(60, 60, 60);
    line-height: 38px;
    margin-top: 60px;
    padding-bottom: 64px;
    border-bottom: 1px solid #e7e6ea;
    position: relative;
}
.home_dongtai {
    background-image: url("../assets/home_bg_2.jpeg");
    background-size: 1599px 408px;
    background-repeat: no-repeat;
    background-position: top center;
    padding: 83px 0 0 0;
    margin-top: 70px;
}
.home_dongtai_content {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 66px;
}
.dongtai_item {
    background-color: #ffffff;
    border-radius: 19px;
    border: 4px solid #ffffff;
    box-shadow: 0px 5px 27px 0px rgba(104, 90, 201, 0.28);
    margin-right: 26px;
    font-size: 18px;
    color: #1e1e1e;
    width: 352px;
    height: 400px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
}
.dongtai_item_header {
    background-color: #000000;
    opacity: 0.4;
    height: 40px;
    width: 440px;
    position: absolute;
    top: 0;
    left: 0;
}
.dongtai_item:last-child {
    margin-right: 0;
}
.dongtai_item img {
    width: 355px;
    height: 254px;
}
.dongtai_item .line {
    width: 400px;
    height: 1px;
    background-color: #e1e7e9;
    margin: 0 auto;
}
.home_dongtai_text {
    padding: 18px 30px 0 30px;
    font-weight: 400;
}
.home_jigou {
    background-image: url("../assets/home-img-3.jpeg");
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: top center;
    padding-bottom: 30px;
    margin-top: 116px;
}
.home_jigou_header {
    padding: 20px 0;
    background-image: url("../assets/home_bg_3.png");
    opacity: 0.7;
}
.home_jigou img {
    width: 100%;
    height: auto;
    margin: 0 auto;
}
.more {
    position: absolute;
    bottom: 29px;
    right: 29px;
    background-image: url("../assets/more_icon.png");
    background-size: 100%;
    background-repeat: no-repeat;
    width: 48px;
    height: 23px;
    cursor: pointer;
}
.icon_home {
    height: 60px;
    width: auto;
    position: absolute;
    right: 0;
    top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue